export { default } from './PatientInfoWidget';
export type { PatientInfoWidgetProps } from './PatientInfoWidget';
